import * as Sentry from "@sentry/nuxt";

Sentry.init({
    dsn: "https://1fdd1af2a981acb21453d07caf0c9bdb@o50847.ingest.us.sentry.io/4508296155955200",

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});
